import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AppConfigService } from '../../app-config.service';
import { SalesToolHostService } from '../salestool.host.service';
import { CREATE_SALES_ACTIVITY_URL } from './routes';
import { SalesPersonAction } from './sales-activity';

@Injectable()
export class SalesActivityApiService {
  constructor(
    private readonly http: HttpClient,
    private readonly host: SalesToolHostService,
    private readonly appConfigService: AppConfigService,
  ) {}

  public createContactUsInboundMessageSalesActivity(
    accountGroupId: string,
    salesPersonId: string,
    message: string,
  ): Observable<any> {
    return this.appConfigService.config$.pipe(
      switchMap((appConfig) => {
        const notes = `${appConfig.userFirstName} ${appConfig.userLastName} (${appConfig.userEmail}) sent a message through "Contact Us" in Partner Center:\n
        ${message}
        `;
        return this.createSalesActivity(
          accountGroupId,
          'inbound-message',
          null,
          null,
          'in-progress',
          notes,
          salesPersonId,
        );
      }),
    );
  }

  public createSalesActivity(
    accountGroupId: string,
    action: SalesPersonAction,
    customActionName: string,
    opportunityId: string,
    status: string,
    notes: string,
    salesPersonId: string,
  ): Observable<any> {
    const host = this.host.host();
    const url = `${host}${CREATE_SALES_ACTIVITY_URL}`;
    const body = {
      accountGroupId: accountGroupId,
      action: action,
      customActionName: customActionName,
      opportunityId: opportunityId,
      status: status,
      notes: notes,
      salesPersonId: salesPersonId,
    };
    return this.http.post(url, body, { withCredentials: true });
  }
}
